// src/services/adminAuth.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ? (process.env.REACT_APP_API_URL + '/api/v1') : '/api/v1'; 

const adminApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add token to requests
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const adminAuthAPI = {
  // Admin login with email + password
  login: async (email, password) => {
    try {
      const response = await adminApi.post('/login', {
        email,
        password,
      });
      
      const { user, token } = response.data;
      
      // Check if user has admin role
      if (user.role !== 'admin' && user.role !== 'super_admin') {
        throw new Error('Access denied. Admin privileges required.');
      }
      
      return { success: true, user, token };
    } catch (error) {
      return {
        success: false,
        error: error.message || error.response?.data?.error || 'Login failed'
      };
    }
  },

  logout: async () => {
    try {
      await adminApi.delete('/logout');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Verify admin session
  verifyAdmin: async () => {
    try {
      const response = await adminApi.get('/users/profile');
      const user = response.data;
      
      if (user.role !== 'admin' && user.role !== 'super_admin') {
        throw new Error('Not authorized');
      }
      
      return { success: true, user };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
};

export default adminApi;